import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function PlayerFeature(){
    return(
        <>
			<div className="player-feature p-4">
				<p className="title-sub p-3 ">
					Player Features
					<div className="bar-break d-flex justify-content-center align-content-center ">
					<div className="main-sub"> </div>
					</div>
				</p>


				<div className="feature-list">
					<div className="player-feature-side">
						<div className="player-feature-block">
							<FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon'/>
							<p className="player-feature-text">Switch between different 3D model views, including cross-section and exploded views.</p>
						</div>
						<div className="player-feature-block">
							<FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon'/>
							<p className="player-feature-text">Control animation and speed.</p>
						</div>
						<div className="player-feature-block">
							<FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon'/>
							<p className="player-feature-text">Easily access related materials such as PDFs, videos, and 360-degree images.</p>
						</div>
					</div>
					<div className="player-feature-side">
						<div className="player-feature-block">
							<FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon'/>
							<p className="player-feature-text">Toggle the visibility of various 3D model components.</p>
						</div>
						<div className="player-feature-block">
							<FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon'/>
							<p className="player-feature-text">Access annotations and engage with interactive quizzes.</p>
						</div>
							<div className="player-feature-block">
							<FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon'/>
							<p className="player-feature-text">Experience anywhere in augmented reality.</p>
						</div>
					</div>
				</div>

			</div>
		</>
    )
}

export default PlayerFeature;